import type {
  FreeSong,
  CustomizableSong,
  AIGeneratedSong,
} from '../../../entities';
import { UserService } from '../userService';
import { User, UserBasicData, PaginatedList } from '../../../entities';
import { UserRepository } from '../../../network/repositories/userRepository';
import { QueryParameters } from '../../../responses/responseTypes';

export default class UserServiceImpl implements UserService {
  userRepository: UserRepository;

  constructor(userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  registerAndLogin(
    email: string,
    password: string,
    cloudflareToken: string
  ): Promise<User> {
    const { userRepository } = this;
    return userRepository.registerAndLogin(email, password, cloudflareToken);
  }

  update(id: string, userData: UserBasicData): Promise<User> {
    const { userRepository } = this;
    return userRepository.update(id, userData);
  }

  isEmailAvailable(email: string): Promise<boolean> {
    const { userRepository } = this;
    return userRepository.checkEmailAvailability(email);
  }

  requestResetPassword(email: string): Promise<string> {
    const { userRepository } = this;
    return userRepository.requestResetPassword(email);
  }

  submitNewPassword(token: string, password: string): Promise<string> {
    const { userRepository } = this;
    return userRepository.submitNewPassword(token, password);
  }

  login(): Promise<User | null> {
    const { userRepository } = this;
    return userRepository.login();
  }

  loginWithCredentials(
    email: string,
    password: string,
    cloudflareToken: string
  ): Promise<User> {
    const { userRepository } = this;
    return userRepository.loginWithCredentials(
      email,
      password,
      cloudflareToken
    );
  }

  loginWithGoogle(token: string): Promise<User> {
    const { userRepository } = this;
    return userRepository.loginWithGoogle(token);
  }

  loginWithFacebook(token: string): Promise<User> {
    const { userRepository } = this;
    return userRepository.loginWithFacebook(token);
  }

  logout(): void {
    const { userRepository } = this;
    userRepository.logout();
  }

  getSessionUser(): Promise<User> {
    const { userRepository } = this;
    return userRepository.getSessionUser();
  }

  deleteAccount(): Promise<string> {
    const { userRepository } = this;
    return userRepository.deleteAccount();
  }

  getSongsLibrary(
    queryParameters: QueryParameters
  ): Promise<PaginatedList<FreeSong | CustomizableSong | AIGeneratedSong>> {
    const { userRepository } = this;
    return userRepository.getSongsLibrary(queryParameters);
  }

  downloadSongLicensePDF(songId: string): Promise<{
    url: string;
    filename: string;
  }> {
    const { userRepository } = this;
    return userRepository.downloadSongLicensePDF(songId);
  }

  resendConfirmationEmail(): Promise<boolean> {
    const { userRepository } = this;
    return userRepository.resendConfirmationEmail();
  }
}
